const CLIENT_NAME_KEY = 'Trimble-FieldSystems-ClientName';
const CLIENT_VERSION_KEY = 'Trimble-FieldSystems-ClientVersion';

export type ScanDataHeaders = {
  [CLIENT_NAME_KEY]: string;
  [CLIENT_VERSION_KEY]: string;
};

export function getDefaultScanDataHeaders(
  clientName: string,
  clientVersion: string
): ScanDataHeaders {
  return {
    [CLIENT_NAME_KEY]: clientName,
    [CLIENT_VERSION_KEY]: clientVersion,
  };
}
